import { render, staticRenderFns } from "./CaseNavigator.vue?vue&type=template&id=4246e3e0&scoped=true"
import script from "./CaseNavigator.vue?vue&type=script&lang=js"
export * from "./CaseNavigator.vue?vue&type=script&lang=js"
import style0 from "./CaseNavigator.vue?vue&type=style&index=0&id=4246e3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4246e3e0",
  null
  
)

export default component.exports